import { h, Fragment } from 'preact';
import { useCoreContext } from '../../../core/Context/CoreProvider';
import { useEffect, useRef, useState } from 'preact/hooks';
import { useAmount } from '../../../core/Context/AmountProvider';
import { ComponentMethodsRef } from '../UIElement/types';

export interface RedirectButtonProps {
    label?: string;
    icon?: string;
    payButton: Function;
    onSubmit: Function;
    name: string;
    showPayButton: boolean;
    setComponentRef: (ref: ComponentMethodsRef) => void;
}

function RedirectButton({
    label = null,
    icon = null,
    payButton,
    onSubmit,
    name,
    showPayButton,
    setComponentRef,
    ...props
}: Readonly<RedirectButtonProps>) {
    const { i18n } = useCoreContext();
    const [status, setStatus] = useState('ready');
    const { amount } = useAmount();

    const redirectButtonRef = useRef<ComponentMethodsRef>({
        setStatus: setStatus
    });

    useEffect(() => {
        setComponentRef(redirectButtonRef.current);
    }, [setComponentRef]);

    const payButtonLabel = () => {
        const isZeroAuth = amount && {}.hasOwnProperty.call(amount, 'value') && amount.value === 0;
        if (isZeroAuth) return `${i18n.get('preauthorizeWith')} ${name}`;
        return `${i18n.get('continueTo')} ${name}`;
    };

    if (!showPayButton) {
        return;
    }

    return (
        <Fragment>
            {payButton({
                ...props,
                status,
                icon,
                classNameModifiers: ['standalone'],
                label: label || payButtonLabel(),
                onClick: onSubmit
            })}
        </Fragment>
    );
}

export default RedirectButton;
